module.exports = __webpack_public_path__ + "static/img/ic_check_red_off@2x.635f20d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_check_red_off@2x.png
// module id = DL87
// module chunks = 1